import { database } from './firebase';
import { ref, push, set, onValue, update, remove } from 'firebase/database';

export class AutosService {
  static async crearAuto(auto) {
    const autosRef = ref(database, 'autos');
    const nuevoAutoRef = push(autosRef);
    const autoConMeta = {
      ...auto,
      id: nuevoAutoRef.key,
      fechaRegistro: new Date().toISOString(),
      timestamp: Date.now(),
    };
    await set(nuevoAutoRef, autoConMeta);
    return autoConMeta;
  }

  static async actualizarAuto(autoId, datos) {
    const autoRef = ref(database, `autos/${autoId}`);
    const datosActualizados = {
      ...datos,
      fechaActualizacion: new Date().toISOString(),
      timestamp: Date.now(),
    };
    await update(autoRef, datosActualizados);
    return datosActualizados;
  }

  static async eliminarAuto(autoId) {
    const autoRef = ref(database, `autos/${autoId}`);
    await remove(autoRef);
  }

  static suscribirseAutos(callback) {
    const autosRef = ref(database, 'autos');
    return onValue(autosRef, (snapshot) => {
      console.log('Snapshot recibido:', snapshot.val());
      const autos = [];
      snapshot.forEach((child) => {
        console.log('Child:', child.key, child.val());
        autos.push(child.val());
      });
      console.log('Autos procesados:', autos);
      callback(autos);
    });
  }

  static async obtenerAutos() {
    return new Promise((resolve, reject) => {
      const autosRef = ref(database, 'autos');
      onValue(autosRef, (snapshot) => {
        const autos = [];
        snapshot.forEach((child) => autos.push(child.val()));
        resolve(autos);
      }, reject);
    });
  }

  static async eliminarTodosLosRegistros() {
    try {
      const autosRef = ref(database, 'autos');
      await remove(autosRef);
      console.log('Todos los registros de autos han sido eliminados exitosamente');
      return true;
    } catch (error) {
      console.error('Error al eliminar todos los registros de autos:', error);
      throw error;
    }
  }
}

export default AutosService;


